import React, { useState } from "react";
import { getFunctions, httpsCallable } from "firebase/functions";
import { doc, updateDoc } from "firebase/firestore";
import app, { db } from "../../firebase/client";

// Admin control (per resident): associate the physical room screen with its Esper
// device. There's no automatic join key yet, so we pull the enterprise's device
// list from Esper (listEsperDevices → GET .../device/) and let the admin pick the
// matching device by name; the chosen UUID is saved to residents/{id}.esperDeviceId
// and used by pushWifiToDevice.
const listFn = httpsCallable(getFunctions(app, "us-central1"), "listEsperDevices");

export default function EsperDeviceLink({ residentId, currentEsperId, onNotice }) {
  const [open, setOpen] = useState(false);
  const [devices, setDevices] = useState(null);
  const [sel, setSel] = useState("");
  const [busy, setBusy] = useState(false);

  const load = async () => {
    setBusy(true);
    try {
      const { data } = await listFn();
      setDevices(data.devices || []);
      setSel(currentEsperId || "");
      setOpen(true);
    } catch (e) {
      onNotice({ ok: false, msg: e && e.message ? e.message : "Could not load Esper devices." });
    } finally {
      setBusy(false);
    }
  };

  const save = async () => {
    if (!residentId) return;
    setBusy(true);
    try {
      await updateDoc(doc(db, "residents", residentId), { esperDeviceId: sel || null });
      onNotice({ ok: true, msg: sel ? "Esper screen linked." : "Esper screen unlinked." });
      setOpen(false);
    } catch (e) {
      onNotice({ ok: false, msg: "Could not save the screen link." });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="manage-group">
      <label>Esper screen</label>
      {!open ? (
        <button onClick={load} disabled={busy} title="Associate this resident's physical screen with its Esper device">
          {busy ? "Loading…" : currentEsperId ? "Linked ✓ — change" : "Link screen"}
        </button>
      ) : (
        <div style={{ display: "flex", gap: "0.3em", alignItems: "center" }}>
          <select value={sel} onChange={(e) => setSel(e.target.value)} disabled={busy}>
            <option value="">— none —</option>
            {(devices || []).map((d) => (
              <option key={d.id} value={d.id}>{d.name}{d.state ? ` (${d.state})` : ""}</option>
            ))}
          </select>
          <button onClick={save} disabled={busy}>{busy ? "…" : "Save"}</button>
        </div>
      )}
    </div>
  );
}
